import { useState, useCallback } from "react";
import "@/App.css";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import CourseCatalog from "@/components/CourseCatalog";
import TeamSection from "@/components/TeamSection";
import HowItWorks from "@/components/HowItWorks";
import Modalities from "@/components/Modalities";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";

function App() {
  const [selectedCourse, setSelectedCourse] = useState("");

  const scrollToContact = useCallback((courseName = "") => {
    if (courseName) {
      setSelectedCourse(courseName);
    }
    setTimeout(() => {
      const el = document.getElementById("contacto");
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 100);
  }, []);

  return (
    <div className="min-h-screen bg-[#1a1a1f]">
      <Navbar onContactClick={() => scrollToContact()} />
      <main>
        <Hero onCtaClick={() => scrollToContact()} />
        <CourseCatalog onCourseSelect={scrollToContact} />
        <TeamSection />
        <HowItWorks />
        <Modalities onCtaClick={() => scrollToContact()} />
        <ContactSection
          selectedCourse={selectedCourse}
          setSelectedCourse={setSelectedCourse}
        />
      </main>
      <Footer />
    </div>
  );
}

export default App;
